module.exports = __webpack_public_path__ + "img/또지면넌변사체가된다.01fcdd17.png";